var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptycookbook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.84,197.52s-5.23,16.54-5.51,23.7S147.25,238,153,243.54s16,8,30.31,7.44,26.73-7.16,26.73-7.16-.27,43.81,0,54,1.11,117.67,1.11,117.67h97.55s-2.48-100.86-1.66-112.71,6.07-46.29,6.07-46.29,36.65,17.08,44.91,17.08,28.11-22,27.29-27.83-29.49-22.6-39.41-30.87-13.78-16.25-20.67-19.56-38-10.2-44.92-11-44.36,1.37-54.56,1.92-27.28,17.92-31.41,20.95a93.66,93.66,0,0,1-9.93,6.06s1.66-1.93-1.1-2.48a23.76,23.76,0,0,0-4.13-.55s-1.38-16-2.48-17.64-17.36-5.51-23.42-5S142.84,197.52,142.84,197.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.2,114.78a47.51,47.51,0,0,1-6.18-9.42c-2.35-5-5.59-13.24.59-18.24s30-8.24,41.5-6.77,21.19,13.24,30.31,29.72,12.07,29.14,10,34.73-10.3,11.77-20,11.48-15.3-10.6-20.89-15.89-23-16.19-25.31-18.55a99.3,99.3,0,0,0-8.54-6.76Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.76,143c0-.88-4.42-11.18-12.07-18.54s-22.37-9.12-27.37-8.83-7.36,2.65-7.36,2.65-5.29,19.43-7.94,26.2a27.53,27.53,0,0,0-.22,18.08,70.28,70.28,0,0,0,7.28,14.88c4.42,7.06,4.42,26.49,4.42,26.49s22.07-10,24.72-13.54,1.17-15.89,2.35-21.78a19.45,19.45,0,0,1,1.06-3.51,17.7,17.7,0,0,0,3.36-5.32S299.76,143.92,299.76,143Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.57,174.93a15.42,15.42,0,0,0,30.25-5.39Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.84,128.91s-4.41,8.81-4.41,12.67v14.61s-17.08,17.91-17.91,22.59-3,16,0,16,17.09-13.51,18.19-16.26,7.71-20.94,7.71-20.94a14.82,14.82,0,0,1,1.93-2.48c1.1-1.11,1.38-8.27,1.38-8.27s3-.28,3-1.93V135C187.76,132.76,177.84,128.91,177.84,128.91Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.5,246.85s-24,4.13-21.49,9.37l.83,3.86s-17.36,22-16.54,22.87,32,19.29,33.07,19.29,20.67-35,24.8-41.89,4.69-13.22-.55-16.53-11-6.34-11-6.34",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-7--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.73,296.18s-2.76,3.58-5.51,5a29.27,29.27,0,0,0-10.2,9.64c-3.31,5-7.44,9.37-5,11.3a8.85,8.85,0,0,0,5,1.93s1.65,3.86,3.86,4.13a29.5,29.5,0,0,0,3.31.28s1.92,1.93,3,1.93H314s1.1,1.38,3.58,0,5-9.65,5.79-12.4.83-8.55.83-8.55l3.86-5.51-8.82-8.82Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-8--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298,146.27l7.95-8c4.25-4.25-3.21-12.5-5.91-15.55a56.33,56.33,0,0,0-23.31-15.58c-5.43-1.94-17.23-5.62-20.22,1.71,0,0-5.3,12.94-5.3,12.94s14.42-1.17,26.78,5.3S298,146.27,298,146.27Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-9--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.46,150.69s9.12-7.36,11.77-2.95-3.53,10.6-8.24,10.6-7.06-1.77-7.06-1.77",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-10--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.68,317.69H135.29V424.07c0,6.4,21.89,11.59,48.9,11.59s48.9-5.19,48.9-11.59Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-11--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.19,300.7c-12.58,0-25.42.82-37.7,3.74-6.86,1.64-19.36,5.1-16.45,15,1.3,4.42,6.41,6.12,10.31,7.52a81.46,81.46,0,0,0,14.81,3.28,188,188,0,0,0,29,2.07c12.59,0,25.44-.82,37.72-3.75,5-1.18,11.19-2.46,14.69-6.53a8.48,8.48,0,0,0-1-12.26c-4.14-3.14-9.89-4.46-14.85-5.57a149.75,149.75,0,0,0-24.06-3.12Q190.45,300.7,184.19,300.7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-12--inject-18"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 184.19,
    cy: 313.97,
    rx: 48.85,
    ry: 10.39,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-13--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.41,340.9H247.18v85.45c0,5.14,17.59,9.31,39.28,9.31s39.28-4.17,39.28-9.31Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-14--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.46,327.26c-10.11,0-20.42.66-30.28,3-5.52,1.31-15.55,4.09-13.21,12,1,3.55,5.14,4.91,8.28,6A65.08,65.08,0,0,0,263.14,351a151.63,151.63,0,0,0,23.32,1.66c10.11,0,20.43-.66,30.3-3,4-.95,9-2,11.8-5.25a6.82,6.82,0,0,0-.81-9.85c-3.32-2.51-7.95-3.57-11.92-4.47a120.89,120.89,0,0,0-19.33-2.51Q291.49,327.26,286.46,327.26Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-15--inject-18"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 286.46,
    cy: 337.92,
    rx: 39.24,
    ry: 8.35,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.9,120.59C379.17,93.38,349.49,77,312.39,84.11c-36.66,7-61.84,41.27-95.38,56.23-35.69,15.92-76.09,7.14-113.19,16.76C77.6,163.9,56.61,184.33,47,213.4,28.18,270.25,43.88,337.74,86.43,375c26.54,23.21,60.91,32.2,93.4,25.76,24.95-5,48.28-17.68,73.23-23.11,43.34-9.44,88.86,4.63,131.52-10.95,45.15-16.5,59.84-64.76,59.55-113.26C443.87,209.31,429.07,155.85,400.9,120.59Z",
    style: {
      fill: "#DC2100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.9,120.59C379.17,93.38,349.49,77,312.39,84.11c-36.66,7-61.84,41.27-95.38,56.23-35.69,15.92-76.09,7.14-113.19,16.76C77.6,163.9,56.61,184.33,47,213.4,28.18,270.25,43.88,337.74,86.43,375c26.54,23.21,60.91,32.2,93.4,25.76,24.95-5,48.28-17.68,73.23-23.11,43.34-9.44,88.86,4.63,131.52-10.95,45.15-16.5,59.84-64.76,59.55-113.26C443.87,209.31,429.07,155.85,400.9,120.59Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Kitchen--inject-18"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.61,
    y: 150.92,
    width: 214.95,
    height: 55.64,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.55 150.88 54.61 150.88 76.1 115.05 248.06 115.05 269.55 150.88",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 76.1,
    y1: 115.05,
    x2: 76.1,
    y2: 75.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249.08,
    y1: 115.05,
    x2: 249.08,
    y2: 75.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.06,147.73l1.24-46.24a4.46,4.46,0,0,1,4.45-4.33h0a4.44,4.44,0,0,1,4.44,4.33L433.43,148",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.3,101.49,423,112.55h9.48l-.3-11.06a4.45,4.45,0,0,0-8.89,0Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.58,
    cy: 179.06,
    r: 31.66,
    transform: "translate(-35.97 180.55) rotate(-22.91)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.58,
    cy: 179.06,
    r: 24.8,
    transform: "translate(155.9 554.65) rotate(-76.84)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.71,
    cy: 101.63,
    r: 0.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.29,141.62,362.37,101a3.91,3.91,0,0,1,3.91-3.8h0a3.92,3.92,0,0,1,3.91,3.81l1.09,40.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.37,101l-.26,9.73h8.34l-.26-9.72a3.91,3.91,0,0,0-7.82,0Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.14,
    cy: 169.16,
    r: 27.83,
    transform: "translate(-12.37 308.45) rotate(-45)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.14,
    cy: 169.16,
    r: 21.81,
    transform: "translate(-17.28 294.31) rotate(-42.87)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.25,
    cy: 101.09,
    r: 0.72,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.25,136.52l1-36a3.46,3.46,0,0,1,3.46-3.37h0a3.46,3.46,0,0,1,3.46,3.37l1,36.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.21,100.53l-.23,8.61h7.38l-.23-8.61a3.46,3.46,0,0,0-6.92,0Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.54,
    cy: 160.91,
    r: 24.64,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.54,
    cy: 160.91,
    r: 19.31,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.27,100.64a.63.63,0,1,0-1.26,0,.63.63,0,0,0,1.26,0Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.24,
    y1: 368.14,
    x2: 416.21,
    y2: 368.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.24,
    y1: 342.71,
    x2: 416.21,
    y2: 342.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.84,197.52s-5.23,16.54-5.51,23.7S147.25,238,153,243.54s16,8,30.31,7.44,26.73-7.16,26.73-7.16-.27,43.81,0,54,1.11,117.67,1.11,117.67h97.55s-2.48-100.86-1.66-112.71,6.07-46.29,6.07-46.29,36.65,17.08,44.91,17.08,28.11-22,27.29-27.83-29.49-22.6-39.41-30.87-13.78-16.25-20.67-19.56-38-10.2-44.92-11-44.36,1.37-54.56,1.92-27.28,17.92-31.41,20.95a93.66,93.66,0,0,1-9.93,6.06s1.66-1.93-1.1-2.48a23.76,23.76,0,0,0-4.13-.55s-1.38-16-2.48-17.64-17.36-5.51-23.42-5S142.84,197.52,142.84,197.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-18)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.2,251.57c1.49-2.46,2.33-4.54,2.15-5.82-.83-5.79-29.49-22.6-39.41-30.87s-13.78-16.25-20.67-19.56-38-10.2-44.92-11a102.39,102.39,0,0,0-11-.11c8.15,8.4-14.2,23.53-9.41,23.93s26.29-2.87,38.61-8.21c0,0,14.79-.42,27.12,7C336.16,213.17,363.21,235.44,383.2,251.57Z",
    style: {
      fill: "#DC2100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.73,266s-11.09-11.09-12.32-14,7-34.5,2.46-26.7A37.06,37.06,0,0,0,320,240.16s-5.35-20.54-5.76-15.61-.41,17.26-.41,17.26-19.3-22.19-16-12.33,7,21.36,7,21.36L278.46,437.75l11.09-3.7,24.64-175.4Z",
    style: {
      fill: "#DC2100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.27,253.31s.41-44-.83-41.9-2.46,11.5-2.46,11.5-6.16-14.38-7-9.45,1.23,15.61,1.23,15.61-7.4,2.88-27.52,6.16-16,0-4.11-5.75,21-18.89,21-25.06-4.11-23.48-16.84-25.91-39.44,22.63-41.49,27.56S147.83,204,147.83,204s2.46,11.51,3.28,15.2-4.51,9.86-4.93,11.5,9.86-2.05,9-.82-10.68,9-8.62,12.74S165.49,252.9,180.69,255A87.28,87.28,0,0,0,210.27,253.31Z",
    style: {
      fill: "#DC2100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.27,253.31s.41-44-.83-41.9-2.46,11.5-2.46,11.5-6.16-14.38-7-9.45,1.23,15.61,1.23,15.61-7.4,2.88-27.52,6.16-16,0-4.11-5.75,21-18.89,21-25.06-4.11-23.48-16.84-25.91-39.44,22.63-41.49,27.56S147.83,204,147.83,204s2.46,11.51,3.28,15.2-4.51,9.86-4.93,11.5,9.86-2.05,9-.82-10.68,9-8.62,12.74S165.49,252.9,180.69,255A87.28,87.28,0,0,0,210.27,253.31Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.73,266s-11.09-11.09-12.32-14,7-34.5,2.46-26.7A37.06,37.06,0,0,0,320,240.16s-5.35-20.54-5.76-15.61-.41,17.26-.41,17.26-19.3-22.19-16-12.33,7,21.36,7,21.36L278.46,437.75l11.09-3.7,24.64-175.4Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.18,415.5h97.56s-.77-31.1-1.31-60.78l-96.8-6.46C210.91,380.29,211.18,415.5,211.18,415.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.2,251.57c1.49-2.46,2.33-4.54,2.15-5.82-.83-5.79-29.49-22.6-39.41-30.87s-13.78-16.25-20.67-19.56-38-10.2-44.92-11a102.39,102.39,0,0,0-11-.11c8.15,8.4-14.2,23.53-9.41,23.93s26.29-2.87,38.61-8.21c0,0,14.79-.42,27.12,7C336.16,213.17,363.21,235.44,383.2,251.57Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M142.84,197.52s-5.23,16.54-5.51,23.7S147.25,238,153,243.54s16,8,30.31,7.44,26.73-7.16,26.73-7.16-.27,43.81,0,54,1.11,117.67,1.11,117.67h97.55s-2.48-100.86-1.66-112.71,6.07-46.29,6.07-46.29,36.65,17.08,44.91,17.08,28.11-22,27.29-27.83-29.49-22.6-39.41-30.87-13.78-16.25-20.67-19.56-38-10.2-44.92-11-44.36,1.37-54.56,1.92-27.28,17.92-31.41,20.95a93.66,93.66,0,0,1-9.93,6.06s1.66-1.93-1.1-2.48a23.76,23.76,0,0,0-4.13-.55s-1.38-16-2.48-17.64-17.36-5.51-23.42-5S142.84,197.52,142.84,197.52Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "210.63 218.19 210.08 243.82 202.92 215.71",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.22,210.2S168.47,224.25,161,225.63",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.45,213.23s-3.58,7.17-7.44,8",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "317.83 239.13 313.15 256.5 310.39 238.86",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "255.28 206.89 245.63 214.88 237.36 414.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,230.45a1.79,1.79,0,1,1-1.79-1.79A1.8,1.8,0,0,1,250,230.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.88,230.45a1.79,1.79,0,1,1-1.79-1.79A1.8,1.8,0,0,1,269.88,230.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.35,265a1.79,1.79,0,1,1-1.79-1.79A1.79,1.79,0,0,1,249.35,265Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.19,265a1.79,1.79,0,1,1-1.79-1.79A1.79,1.79,0,0,1,269.19,265Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.66,304.17a1.79,1.79,0,1,1-1.79-1.79A1.79,1.79,0,0,1,248.66,304.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.5,304.17a1.79,1.79,0,1,1-1.79-1.79A1.79,1.79,0,0,1,268.5,304.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.79,167.49s-7.17,0-9.65.82-11.57,17.64-14,23.7a27.41,27.41,0,0,0-1.66,12.4l13.23-6.34,3.86,17.64s20.94-16.53,23.7-22-3.58-20.95-3.58-20.95Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.83,178.51s-13.23,3.58-14.61,10.2,9.92,17.08,12.13,19,22.59-2.21,31.69-4.41,21.22-8,20.94-12.68-5.79-6.61-7.44-10.47-2.76-6.06-7.72-6.61a94.65,94.65,0,0,0-14.88-.28C274,173.55,255.83,178.51,255.83,178.51Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.28,206.89s-1.38-2.75-6.62-2.48-9.37,6.06-9.37,6.06S249.49,212.68,255.28,206.89Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.28,206.89s2.2-4.13,6.61.28S269.05,219,269.05,219s-5.78,2.48-11.29-3.31S255.28,206.89,255.28,206.89Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298,183.47s.28,5.24-9.65,10.47a156.65,156.65,0,0,1-22,9.09",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.22,190.42s7.4-4.75,8.5-8-2.2-5-2.2-5",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.83,205.79s-6.62-8-6.62-14,2.48-6.89,2.48-6.89",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.2,114.78a47.51,47.51,0,0,1-6.18-9.42c-2.35-5-5.59-13.24.59-18.24s30-8.24,41.5-6.77,21.19,13.24,30.31,29.72,12.07,29.14,10,34.73-10.3,11.77-20,11.48-15.3-10.6-20.89-15.89-23-16.19-25.31-18.55a99.3,99.3,0,0,0-8.54-6.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-18)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.37,82.75c4.5,5.48,15.09,19.34,16.06,29.66,1.23,13.14-23.83,6.57-23.83,6.57s16.43-9.86,11.5-8.63-9-1.64-16.43-1.64-16.84-9.86-16.84-6.57.82,4.11,2.88,7-2.06,0,7.8,14c3,4.29,5.32,9.32,7.59,14.43,1.36,1.06,2.54,2,3.42,2.87,5.59,5.29,11.18,15.59,20.89,15.89s18-5.89,20-11.48-.89-18.25-10-34.73C315.28,97.18,307.79,87.2,299.37,82.75Z",
    style: {
      fill: "#DC2100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.37,82.75c4.5,5.48,15.09,19.34,16.06,29.66,1.23,13.14-23.83,6.57-23.83,6.57s16.43-9.86,11.5-8.63-9-1.64-16.43-1.64-16.84-9.86-16.84-6.57.82,4.11,2.88,7-2.06,0,7.8,14c3,4.29,5.32,9.32,7.59,14.43,1.36,1.06,2.54,2,3.42,2.87,5.59,5.29,11.18,15.59,20.89,15.89s18-5.89,20-11.48-.89-18.25-10-34.73C315.28,97.18,307.79,87.2,299.37,82.75Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M256.2,114.78a47.51,47.51,0,0,1-6.18-9.42c-2.35-5-5.59-13.24.59-18.24s30-8.24,41.5-6.77,21.19,13.24,30.31,29.72,12.07,29.14,10,34.73-10.3,11.77-20,11.48-15.3-10.6-20.89-15.89-23-16.19-25.31-18.55a99.3,99.3,0,0,0-8.54-6.76Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,104.56s-2.92-1.62-7.79-7.79",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.66,94.86a9.76,9.76,0,0,1-.08-2.63",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.45,105.86a37.94,37.94,0,0,1-4-8.06",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.15,118.85s8.12,1.62,15.26.33",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.16,134.07c.74,0,1.5,0,2.26,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.51,132.16a63.62,63.62,0,0,0,10.09,1.68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.94,138.32s8.07,8.78,13.91,10.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.76,143c0-.88-4.42-11.18-12.07-18.54s-22.37-9.12-27.37-8.83-7.36,2.65-7.36,2.65-5.29,19.43-7.94,26.2a27.53,27.53,0,0,0-.22,18.08,70.28,70.28,0,0,0,7.28,14.88c4.42,7.06,4.42,26.49,4.42,26.49s22.07-10,24.72-13.54,1.17-15.89,2.35-21.78a19.45,19.45,0,0,1,1.06-3.51,17.7,17.7,0,0,0,3.36-5.32S299.76,143.92,299.76,143Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-18)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.16,130.87l-6.49-.39a206.77,206.77,0,0,1-7,24.65c-4.11,11.09-9.86,17.66-15.61,19.72s-12.32-.82-9.86,2.46c1.46,1.95,10.32,10.28,20.19,17.75,3.31-1.84,6-3.55,6.81-4.64,2.65-3.53,1.17-15.89,2.35-21.78a19.45,19.45,0,0,1,1.06-3.51,17.7,17.7,0,0,0,3.36-5.32s11.77-15.89,11.77-16.78C299.76,142.39,297.4,136.74,293.16,130.87Z",
    style: {
      fill: "#DC2100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.16,130.87l-6.49-.39a206.77,206.77,0,0,1-7,24.65c-4.11,11.09-9.86,17.66-15.61,19.72s-12.32-.82-9.86,2.46c1.46,1.95,10.32,10.28,20.19,17.75,3.31-1.84,6-3.55,6.81-4.64,2.65-3.53,1.17-15.89,2.35-21.78a19.45,19.45,0,0,1,1.06-3.51,17.7,17.7,0,0,0,3.36-5.32s11.77-15.89,11.77-16.78C299.76,142.39,297.4,136.74,293.16,130.87Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M299.76,143c0-.88-4.42-11.18-12.07-18.54s-22.37-9.12-27.37-8.83-7.36,2.65-7.36,2.65-5.29,19.43-7.94,26.2a27.53,27.53,0,0,0-.22,18.08,70.28,70.28,0,0,0,7.28,14.88c4.42,7.06,4.42,26.49,4.42,26.49s22.07-10,24.72-13.54,1.17-15.89,2.35-21.78a19.45,19.45,0,0,1,1.06-3.51,17.7,17.7,0,0,0,3.36-5.32S299.76,143.92,299.76,143Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.38,136.27s-.88,3.53-3.82,4.7-6.77.89-5.6,2.95,5.6,3.23,5.6,3.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.44,154.51s5,2.06,7.94.59",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.39,139.21s-.59,5,5.59,4.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.67,134.5s2.94,4.71,7.06,1.77",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.86,132.44s5.3-1.77,7.65,4.71",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.38,130.09s-3.53-5.3-8.53-1.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.68,152.16s.29,4.41,2.64,5.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.46,157.75s-8.24,10-13.83,11.77",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.7,135.38s-3.83,4.57-3.4,8.43,6.38,7.72,8.08,7.72,6.38-7,6.38-7S293,137.14,288.7,135.38Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.44,122.29s-3.31,3.31-11.3,3.31a76.1,76.1,0,0,1-13.5-1.1S255.55,120.09,262.44,122.29Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.57,174.93a15.42,15.42,0,0,0,30.25-5.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-18)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.57,174.93a15.42,15.42,0,0,0,30.25-5.39Z",
    style: {
      opacity: 0.42
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M206.57,174.93a15.42,15.42,0,0,0,30.25-5.39Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.76,135a14.69,14.69,0,0,0,1.65-6.06c0-3-1.1-8-2.75-7.44s-1.65,4.68-1.38,6.06a10.4,10.4,0,0,1-.27,3.58s-1.38,2.48-.28,4.41S187.76,135,187.76,135Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.57,174.93l-29.86-64.08a3.17,3.17,0,0,0-4.23-1.52h0A3.16,3.16,0,0,0,171,113.6l1.31,2.63",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.46,124.77s0,3.31,1.38,4.14,8.54,5,8.82,2.48-5-5.79-6.61-6.62S177.84,124.22,176.46,124.77Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.84,128.91s-4.41,8.81-4.41,12.67v14.61s-17.08,17.91-17.91,22.59-3,16,0,16,17.09-13.51,18.19-16.26,7.71-20.94,7.71-20.94a14.82,14.82,0,0,1,1.93-2.48c1.1-1.11,1.38-8.27,1.38-8.27s3-.28,3-1.93V135C187.76,132.76,177.84,128.91,177.84,128.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-18)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.71,178.51c1.1-2.76,7.71-20.94,7.71-20.94a14.82,14.82,0,0,1,1.93-2.48c1.1-1.11,1.38-8.27,1.38-8.27s3-.28,3-1.93V135c0-.48-.47-1-1.2-1.6l-2,9-7.93.79a20.15,20.15,0,0,1,2.77,6c.8,3.17-.39,8.72-2.37,13.87-1.87,4.86-20.66,27.69-22.79,30.28.23.93.64,1.5,1.32,1.5C158.55,194.77,172.61,181.26,173.71,178.51Z",
    style: {
      fill: "#DC2100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.71,178.51c1.1-2.76,7.71-20.94,7.71-20.94a14.82,14.82,0,0,1,1.93-2.48c1.1-1.11,1.38-8.27,1.38-8.27s3-.28,3-1.93V135c0-.48-.47-1-1.2-1.6l-2,9-7.93.79a20.15,20.15,0,0,1,2.77,6c.8,3.17-.39,8.72-2.37,13.87-1.87,4.86-20.66,27.69-22.79,30.28.23.93.64,1.5,1.32,1.5C158.55,194.77,172.61,181.26,173.71,178.51Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M177.84,128.91s-4.41,8.81-4.41,12.67v14.61s-17.08,17.91-17.91,22.59-3,16,0,16,17.09-13.51,18.19-16.26,7.71-20.94,7.71-20.94a14.82,14.82,0,0,1,1.93-2.48c1.1-1.11,1.38-8.27,1.38-8.27s3-.28,3-1.93V135C187.76,132.76,177.84,128.91,177.84,128.91Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "184.73 146.82 183.9 144.61 181.15 144.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.29,
    y1: 139.93,
    x2: 186.66,
    y2: 140.2,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.84,
    y1: 134.69,
    x2: 186.93,
    y2: 136.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.5,246.85s-24,4.13-21.49,9.37l.83,3.86s-17.36,22-16.54,22.87,32,19.29,33.07,19.29,20.67-35,24.8-41.89,4.69-13.22-.55-16.53-11-6.34-11-6.34",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-18)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.62,243.82c-5.24-3.31-11-6.34-11-6.34l-3.35,3.45c3.4,2.9,9.2,8.25,9.49,11.14.41,4.11-5.75,12.33-6.57,14s-8.22-11.5-15.2-11.5.3,2.6,4,6.64,4.17,10.61,1.29,14.72c-2.7,3.86-31.8,1.92-26.55,12.87,9.52,5.69,22.89,13.47,23.61,13.47,1.1,0,20.67-35,24.8-41.89S390.86,247.13,385.62,243.82Z",
    style: {
      fill: "#DC2100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.62,243.82c-5.24-3.31-11-6.34-11-6.34l-3.35,3.45c3.4,2.9,9.2,8.25,9.49,11.14.41,4.11-5.75,12.33-6.57,14s-8.22-11.5-15.2-11.5.3,2.6,4,6.64,4.17,10.61,1.29,14.72c-2.7,3.86-31.8,1.92-26.55,12.87,9.52,5.69,22.89,13.47,23.61,13.47,1.1,0,20.67-35,24.8-41.89S390.86,247.13,385.62,243.82Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M365.5,246.85s-24,4.13-21.49,9.37l.83,3.86s-17.36,22-16.54,22.87,32,19.29,33.07,19.29,20.67-35,24.8-41.89,4.69-13.22-.55-16.53-11-6.34-11-6.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.42,258.42s8.54-3.3,14.6,2.76,7.17,8.54,7.17,8.54a18,18,0,0,0-6.89-12.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.73,296.18s-2.76,3.58-5.51,5a29.27,29.27,0,0,0-10.2,9.64c-3.31,5-7.44,9.37-5,11.3a8.85,8.85,0,0,0,5,1.93s1.65,3.86,3.86,4.13a29.5,29.5,0,0,0,3.31.28s1.92,1.93,3,1.93H314s1.1,1.38,3.58,0,5-9.65,5.79-12.4.83-8.55.83-8.55l3.86-5.51-8.82-8.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-7--inject-18)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.73,296.18a26.88,26.88,0,0,1-2.17,2.41l3.94,9.09s-3,14.6-5.15,18.63c-.87,1.65-2.68,2.28-4.52,2.69a4.94,4.94,0,0,0,2.39,1.35H314s1.1,1.38,3.58,0,5-9.65,5.79-12.4.83-8.55.83-8.55l3.86-5.51-8.82-8.82Z",
    style: {
      fill: "#DC2100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.73,296.18a26.88,26.88,0,0,1-2.17,2.41l3.94,9.09s-3,14.6-5.15,18.63c-.87,1.65-2.68,2.28-4.52,2.69a4.94,4.94,0,0,0,2.39,1.35H314s1.1,1.38,3.58,0,5-9.65,5.79-12.4.83-8.55.83-8.55l3.86-5.51-8.82-8.82Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M316.73,296.18s-2.76,3.58-5.51,5a29.27,29.27,0,0,0-10.2,9.64c-3.31,5-7.44,9.37-5,11.3a8.85,8.85,0,0,0,5,1.93s1.65,3.86,3.86,4.13a29.5,29.5,0,0,0,3.31.28s1.92,1.93,3,1.93H314s1.1,1.38,3.58,0,5-9.65,5.79-12.4.83-8.55.83-8.55l3.86-5.51-8.82-8.82Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.48,279.64s32.51,17.09,34.44,18.19,2.76,4.41,2.21,8,3.3,17.09-.83,17.09-22.05-5.51-32.52-11.3-15.71-14.33-15.71-15.43S327.48,279.64,327.48,279.64Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298,146.27l7.95-8c4.25-4.25-3.21-12.5-5.91-15.55a56.33,56.33,0,0,0-23.31-15.58c-5.43-1.94-17.23-5.62-20.22,1.71,0,0-5.3,12.94-5.3,12.94s14.42-1.17,26.78,5.3S298,146.27,298,146.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-8--inject-18)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.72,107.19c-4.61-1.65-13.83-4.53-18.33-.86,3.63-.1,9.36.93,18,5.26,18.08,9,18.49,11.91,17.25,16.43-.51,1.88-2.86,4.32-5.44,6.53A61.79,61.79,0,0,1,298,146.27l7.95-8c4.25-4.25-3.21-12.5-5.91-15.55A56.33,56.33,0,0,0,276.72,107.19Z",
    style: {
      fill: "#DC2100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.72,107.19c-4.61-1.65-13.83-4.53-18.33-.86,3.63-.1,9.36.93,18,5.26,18.08,9,18.49,11.91,17.25,16.43-.51,1.88-2.86,4.32-5.44,6.53A61.79,61.79,0,0,1,298,146.27l7.95-8c4.25-4.25-3.21-12.5-5.91-15.55A56.33,56.33,0,0,0,276.72,107.19Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M298,146.27l7.95-8c4.25-4.25-3.21-12.5-5.91-15.55a56.33,56.33,0,0,0-23.31-15.58c-5.43-1.94-17.23-5.62-20.22,1.71,0,0-5.3,12.94-5.3,12.94s14.42-1.17,26.78,5.3S298,146.27,298,146.27Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.46,150.69s9.12-7.36,11.77-2.95-3.53,10.6-8.24,10.6-7.06-1.77-7.06-1.77",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-9--inject-18)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.46,150.69s9.12-7.36,11.77-2.95-3.53,10.6-8.24,10.6-7.06-1.77-7.06-1.77",
    style: {
      fill: "#DC2100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.46,150.69s9.12-7.36,11.77-2.95-3.53,10.6-8.24,10.6-7.06-1.77-7.06-1.77",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M289.46,150.69s9.12-7.36,11.77-2.95-3.53,10.6-8.24,10.6-7.06-1.77-7.06-1.77",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--cooking-pots--inject-18"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 73.41,
    y1: 415.5,
    x2: 396.04,
    y2: 415.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.68,317.69H135.29V424.07c0,6.4,21.89,11.59,48.9,11.59s48.9-5.19,48.9-11.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-10--inject-18)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.68,317.69H135.29V424.07c0,6.4,21.89,11.59,48.9,11.59s48.9-5.19,48.9-11.59Z",
    style: {
      opacity: 0.42
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.45,317.69V433.92a176.22,176.22,0,0,0,22.46,1.71V317.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.34,317.69v117.9c2.39,0,4.74-.15,7-.29V317.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.87,317.69V435.05q3.65-.3,7-.72V317.69Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.68,317.69H135.29V424.07c0,6.4,21.89,11.59,48.9,11.59s48.9-5.19,48.9-11.59Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.19,300.7c-12.58,0-25.42.82-37.7,3.74-6.86,1.64-19.36,5.1-16.45,15,1.3,4.42,6.41,6.12,10.31,7.52a81.46,81.46,0,0,0,14.81,3.28,188,188,0,0,0,29,2.07c12.59,0,25.44-.82,37.72-3.75,5-1.18,11.19-2.46,14.69-6.53a8.48,8.48,0,0,0-1-12.26c-4.14-3.14-9.89-4.46-14.85-5.57a149.75,149.75,0,0,0-24.06-3.12Q190.45,300.7,184.19,300.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-11--inject-18)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.19,300.7c-12.58,0-25.42.82-37.7,3.74-6.86,1.64-19.36,5.1-16.45,15,1.3,4.42,6.41,6.12,10.31,7.52a81.46,81.46,0,0,0,14.81,3.28,188,188,0,0,0,29,2.07c12.59,0,25.44-.82,37.72-3.75,5-1.18,11.19-2.46,14.69-6.53a8.48,8.48,0,0,0-1-12.26c-4.14-3.14-9.89-4.46-14.85-5.57a149.75,149.75,0,0,0-24.06-3.12Q190.45,300.7,184.19,300.7Z",
    style: {
      opacity: 0.42
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M184.19,300.7c-12.58,0-25.42.82-37.7,3.74-6.86,1.64-19.36,5.1-16.45,15,1.3,4.42,6.41,6.12,10.31,7.52a81.46,81.46,0,0,0,14.81,3.28,188,188,0,0,0,29,2.07c12.59,0,25.44-.82,37.72-3.75,5-1.18,11.19-2.46,14.69-6.53a8.48,8.48,0,0,0-1-12.26c-4.14-3.14-9.89-4.46-14.85-5.57a149.75,149.75,0,0,0-24.06-3.12Q190.45,300.7,184.19,300.7Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 184.19,
    cy: 313.97,
    rx: 48.85,
    ry: 10.39,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-12--inject-18)"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 184.19,
    cy: 313.97,
    rx: 48.85,
    ry: 10.39,
    style: {
      opacity: 0.65
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 184.19,
    cy: 313.97,
    rx: 48.85,
    ry: 10.39,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.48,346.63s-7.16-12.13-5-16,11.85-.27,14.61,3.31,5.24,13.51,3.86,13.78-3.58.55-4.14-1.37-3.3-10.2-5-11.31-5.51-3.3-5.51-.82,4.14,11,3.58,12.4S138.14,348.28,136.48,346.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.41,340.9H247.18v85.45c0,5.14,17.59,9.31,39.28,9.31s39.28-4.17,39.28-9.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-13--inject-18)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.41,340.9H247.18v85.45c0,5.14,17.59,9.31,39.28,9.31s39.28-4.17,39.28-9.31Z",
    style: {
      opacity: 0.42
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M325.41,340.9H247.18v85.45c0,5.14,17.59,9.31,39.28,9.31s39.28-4.17,39.28-9.31Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.79,340.9v93.36a142.14,142.14,0,0,0,18,1.38V340.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.59,340.9v94.71q2.9-.08,5.64-.24V340.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.05,340.9v94.27c1.95-.16,3.84-.35,5.64-.57V340.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.46,327.26c-10.11,0-20.42.66-30.28,3-5.52,1.31-15.55,4.09-13.21,12,1,3.55,5.14,4.91,8.28,6A65.08,65.08,0,0,0,263.14,351a151.63,151.63,0,0,0,23.32,1.66c10.11,0,20.43-.66,30.3-3,4-.95,9-2,11.8-5.25a6.82,6.82,0,0,0-.81-9.85c-3.32-2.51-7.95-3.57-11.92-4.47a120.89,120.89,0,0,0-19.33-2.51Q291.49,327.26,286.46,327.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-14--inject-18)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.46,327.26c-10.11,0-20.42.66-30.28,3-5.52,1.31-15.55,4.09-13.21,12,1,3.55,5.14,4.91,8.28,6A65.08,65.08,0,0,0,263.14,351a151.63,151.63,0,0,0,23.32,1.66c10.11,0,20.43-.66,30.3-3,4-.95,9-2,11.8-5.25a6.82,6.82,0,0,0-.81-9.85c-3.32-2.51-7.95-3.57-11.92-4.47a120.89,120.89,0,0,0-19.33-2.51Q291.49,327.26,286.46,327.26Z",
    style: {
      opacity: 0.42
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M286.46,327.26c-10.11,0-20.42.66-30.28,3-5.52,1.31-15.55,4.09-13.21,12,1,3.55,5.14,4.91,8.28,6A65.08,65.08,0,0,0,263.14,351a151.63,151.63,0,0,0,23.32,1.66c10.11,0,20.43-.66,30.3-3,4-.95,9-2,11.8-5.25a6.82,6.82,0,0,0-.81-9.85c-3.32-2.51-7.95-3.57-11.92-4.47a120.89,120.89,0,0,0-19.33-2.51Q291.49,327.26,286.46,327.26Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 286.46,
    cy: 337.92,
    rx: 39.24,
    ry: 8.35,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-15--inject-18)"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 286.46,
    cy: 337.92,
    rx: 39.24,
    ry: 8.35,
    style: {
      opacity: 0.65
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 286.46,
    cy: 337.92,
    rx: 39.24,
    ry: 8.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.14,364.15s-5.76-9.74-4-12.84,9.52-.22,11.74,2.65,4.2,10.85,3.1,11.07-2.88.45-3.32-1.1-2.66-8.19-4-9.08-4.43-2.66-4.43-.66,3.33,8.85,2.88,10S249.47,365.48,248.14,364.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.7,268.91c0,6.2,5.61,6.2,5.61,12.39s-5.61,6.19-5.61,12.39,5.61,6.19,5.61,12.39-5.61,6.2-5.61,12.39",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.31,256.53c0,3.9-2.23,5.34-3.88,7.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.8,268.44c0,5-5.61,5-5.61,10s5.61,5,5.61,10-5.61,5-5.61,10,5.61,5,5.61,10-5.61,5-5.61,10",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.29,256.53c0,6.19-5.61,6.19-5.61,12.38s5.61,6.2,5.61,12.39-5.61,6.19-5.61,12.39,5.61,6.19,5.61,12.39-5.61,6.2-5.61,12.39",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.39,307.69a5.59,5.59,0,0,1,.66,2.78c0,4.66-4.23,4.66-4.23,9.33s4.23,4.67,4.23,9.34-4.23,4.68-4.23,9.35",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.5,300.77c0,3.77-4.23,3.77-4.23,7.54s4.23,3.77,4.23,7.54-4.23,3.77-4.23,7.55,4.23,3.77,4.23,7.54-4.23,3.77-4.23,7.55",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,315c-1.1,1.22-2.25,2.38-2.25,4.81,0,4.67,4.23,4.67,4.23,9.34s-4.23,4.68-4.23,9.35",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1433297395706177px"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptycookbook);
export default __webpack_public_path__ + "static/media/emptycookbook.ce4fbb431122148f8024ad8c4c0bc5ac.svg";
export { ForwardRef as ReactComponent };